<script setup lang="ts">
import { onMounted } from "vue";
import { RouterView } from "vue-router";
import { useStore } from "@/stores";
import { success } from "@/utils";

const { toggleNetwork, nutuiThemeVars } = useStore();

onMounted(async () => {
  document.onkeydown = (evt: KeyboardEvent) => {
    if (evt.altKey && evt.key === "d") {
      const visible = toggleNetwork();
      success("网络监控" + (visible ? "已开启" : "已关闭"));
      return;
    }
  };
});
</script>
<template>
  <nut-config-provider :theme-vars="nutuiThemeVars" style="height: 100%">
    <RouterView />
  </nut-config-provider>
</template>
